module.exports = Backbone.Model.extend({
    defaults: {
    	id: '',
    	shortText: {},
    	longText: {}
	}
});